import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const HydrostaticHeadTester = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        '/img/instruments/HHT.png',
        '/img/instruments/HHT.png'
    ];


    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/packaingtesting">Packaging Instruments</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Hydrostatic Head Tester</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Hydrostatic Head Tester</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    Hydrostatic Head Tester (Hydro tester) is used for determining the water penetration resistance of high-waterproof clothing or coated fabrics by conducting the hydrostatic pressure test. It is an Open-Plan. The size of specimen is unrestricted. It is equipped with a 7 inch-touch screen. The value is displayed in high precision. At the same time,
                                    it also has the curve diagram of pressure and display of the temperature. It is very easy for operation to obtain precise pressurization rates and pressure values.
                                    <br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Box Compression Tester"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>

                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default HydrostaticHeadTester